import React, { useRef } from 'react'
import useStore from '@/store'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import type { Props } from './types'
import Basel from '@/components/table-view/basel'
import Switzerland from '@/components/table-view/switzerland'
import styles from './style.module.scss'

const TableView: React.FC<Props> = () => {
  const animContainerElRefBasel = useRef(null)
  const animContainerElRefSwitzerland = useRef(null)
  const activeMode = useStore((state) => state.activeMode)
  const classes = classNames(styles['table-view'])
  const animClassNames = {
    enter: styles['anim--enter'],
    enterActive: styles['anim--enter-active'],
    enterDone: styles['anim--enter-done'],
    exit: styles['anim--exit'],
    exitActive: styles['anim--exit-active'],
    exitDone: styles['anim--exit-done'],
  }
  return (
    <div className={classes}>
      <TransitionGroup component={null}>
        {activeMode === 'basel' ? (
          <CSSTransition
            key={activeMode}
            nodeRef={animContainerElRefBasel}
            classNames={animClassNames}
            timeout={500}
          >
            <Basel customRef={animContainerElRefBasel} />
          </CSSTransition>
        ) : activeMode === 'switzerland' ? (
          <CSSTransition
            key={activeMode}
            nodeRef={animContainerElRefSwitzerland}
            classNames={animClassNames}
            timeout={500}
          >
            <Switzerland customRef={animContainerElRefSwitzerland} />
          </CSSTransition>
        ) : null}
      </TransitionGroup>
    </div>
  )
}

export default React.memo(TableView)
